export const errorMessages = {
    clinic_not_selected: 'Por favor, escolha uma clínica.',
    clinic_selection_error: 'Clínica não foi selecionada.',
    employee_email_already_exists: 'Já existe um funcionário com este e-mail.',
    initial_time_gt_end_time: 'A hora de término não pode ser menor que a hora de início.',
    insurance_not_selected: 'Nenhum convênio selecionado.',
    login_failed: 'E-mail ou senha incorretos.',
    patient_not_deleted: 'Paciente não foi excluído.',
    patient_not_edited: 'Paciente não foi editado.',
    patient_not_registered: 'Paciente não foi cadastrado.',
    relation_not_deleted: 'Relação não excluída.',
    relations_not_altered: 'Relações não alteradas.',
    schedule_not_deleted: 'Agenda não excluída.',
    schedule_not_edited: 'Informações da agenda não foram alteradas.',
    schedule_not_registered: 'Agenda não cadastrada.',
    scheduling_not_registered: 'Agendamento não foi registrado.',
    time_table_not_deleted: 'Grade de horário não foi excluída.',
    time_table_not_edited: 'Informações da grade de horário não foram alteradas.',
    time_table_not_registered: 'Grade de horário não foi cadastrada, '
        + 'verifique se o horário não conflita com outras grades existentes.',

    employee_not_removed: 'Funcionário(a) não foi excluído(a).'
}